import React, { useRef, useCallback } from 'react'

export function ThreeFieldReflection({ fields, values = {}, onChange, maxChars = 100, disabled = false }) {
  const textareaRefs = useRef({})

  const autoResize = useCallback((el) => {
    if (!el) return
    el.style.height = 'auto'
    el.style.height = el.scrollHeight + 'px'
  }, [])

  function handleChange(key, val) {
    onChange({ ...values, [key]: val })
    autoResize(textareaRefs.current[key])
  }

  return (
    <div style={styles.wrap}>
      {fields.map((field) => (
        <div key={field.key} style={styles.row}>
          <span style={{ ...styles.badge, background: field.color + '22', color: field.color }}>
            {field.label}
          </span>
          <textarea
            ref={(el) => {
              textareaRefs.current[field.key] = el
              if (el) autoResize(el)
            }}
            style={styles.input}
            value={values[field.key] ?? ''}
            placeholder={disabled ? '' : `${field.key}…`}
            maxLength={maxChars}
            disabled={disabled}
            rows={1}
            onChange={(e) => handleChange(field.key, e.target.value)}
            aria-label={field.label}
          />
        </div>
      ))}
    </div>
  )
}

const styles = {
  wrap: { padding: '8px 14px 12px', display: 'flex', flexDirection: 'column', gap: '8px' },
  row: { display: 'flex', alignItems: 'flex-start', gap: '8px' },
  badge: {
    fontSize: '9px', fontWeight: 700, padding: '2px 5px', borderRadius: '3px',
    textTransform: 'uppercase', letterSpacing: '0.04em', flexShrink: 0, width: '38px',
    textAlign: 'center', marginTop: '3px',
  },
  input: {
    flex: 1, border: 'none', outline: 'none', background: 'transparent',
    fontSize: '12px', color: 'var(--text-primary)', padding: '2px 0',
    borderBottom: '1px solid var(--border)', resize: 'none', fontFamily: 'inherit', overflow: 'hidden',
  },
}
